// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1ZZNr","content":"Consent_content__1ONfa","footer":"Consent_footer__3lRd3"};